import { render, staticRenderFns } from "./ShapeSelector.vue?vue&type=template&id=15623fcc&scoped=true&"
import script from "./ShapeSelector.vue?vue&type=script&lang=js&"
export * from "./ShapeSelector.vue?vue&type=script&lang=js&"
import style0 from "./ShapeSelector.vue?vue&type=style&index=0&id=15623fcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15623fcc",
  null
  
)

export default component.exports